import gql from 'graphql-tag';

export class QesMutations {
  static createQesFile = gql`
    mutation CreateQesFile($documentId: String!, $fileType: QesFileType!, $name: String!) {
      createDocumentQesFile(documentId: $documentId, fileType: $fileType, name: $name) {
        id
      }
    }
  `;

  static deleteQesFile = gql`
    mutation DeleteQesFile($documentId: String!, $fileId: String!) {
      deleteDocumentQesFile(documentId: $documentId, fileId: $fileId)
    }
  `;
}
